import { useState } from "react";
import { useDispatch } from "react-redux";
import { modalActions } from "../../storage/modals";

const RPMPass = (props) => {
  const packs = props.rpmpass.products;
  const [pack, setPack] = useState(0);
  const [price, setPrice] = useState(packs[0].price);
  const dispatch = useDispatch();

  const setPackHandler = (event) => {
    const value = event.target.value;
    setPack(value);
    setPrice(packs[value].price);
  };

//   const setAmountHandler = event => {
//     let value = event.target.value.trim();
//     console.log(value);

//     if(value === ""){
//         setAmount("");
//         setPrice(parseFloat(packs[pack].price));
//         return;
//     }

//     value = parseFloat(value);
//     const min = parseFloat(packs[pack].dynamic.min);
//     const max = parseFloat(packs[pack].dynamic.max);
//     const step = parseFloat(packs[pack].dynamic.step);

//     if(value > max){
//         value = max;
//     }
//     else if(value < min){
//         value = min;
//     }

//     setAmount(value);
//     setPrice((parseFloat(value) / parseFloat(step)) * parseFloat(packs[pack].price));
//   };

  const addToCart = () => {
    dispatch(modalActions.showAddToCartModal(packs[pack].id));
  }

  return (
    <div className="supplement supplement_rpmpass" style={{background: `${props.rpmpass.bg} no-repeat center center/cover`}}>
      <img className="supplement-img" src={props.rpmpass.icon} alt="RPMPass" />
      <div className="supplement-body">
        <h4 className="supplement-title">RPMPass</h4>
        <div className="supplement-description">
          <p className="supplement-p">
            Получите награды за игру на сервере. Огромное количество уникальных
            предметов.
          </p>
          <p className="supplement-p">
            Истинному коллекционеру мимо не пройти!
          </p>
        </div>
        <div className="rpmpass-input">
          <div className="rpmpass-input-select">
            <select
              className="rpmpass-input__select"
              onChange={setPackHandler}
              defaultValue={pack}
            >
              {packs.map((item, index) => {
                return (
                  <option value={index} key={item.id}>
                    {item.name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
        <button type="button" className="supplement-cta" onClick={addToCart}>
          Купить за {price} ₽
        </button>
      </div>
    </div>
  );
};

export default RPMPass;
